document.addEventListener('DOMContentLoaded', () => {
  UWX.MenuNth('.c-tab-menu li', '.c-tab_data-item', '--actived')

  UWX.SearchParamURL('type', [
    { param: 'industry', selector: '.c-tab-item.industry'},
    { param: 'problem', selector: '.c-tab-item.problem'},
  ], '--actived')
  UWX.SearchParamAccess('type', [
    { param: 'industry', selector: '.c-tab-item.industry' },
    { param: 'problem', selector: '.c-tab-item.problem' },
  ])

  UWX.RadioClass('.c-sort-item', '--actived')
  UWX.ClickAction('.c-sort-item', '--actived')
  UWS.MultiFilter('.c-sort-item', '.c-case_content-item', {
    triggerActClass: '--actived',
    targetDeactClass: 'hide',
    URLsearch: 'tag',
  })

  Array.from(document.querySelectorAll('.c-tab-item')).forEach(tab => {
    tab.addEventListener('click', elm => {
      const all = document.querySelector('.c-tab_data-item .c-sort-item.--actived[data-uw-filter-clear=""]')
      if(all){
        const otherAll = document.querySelector('.c-tab_data-item.--actived .c-sort-item[data-uw-filter-clear=""]')
        if(!otherAll.classList.contains('--actived')){
          otherAll.classList.add('--actived')
        }
      }
    })
  })

  Array.from(document.querySelectorAll('.c-sort-item')).forEach(tab => {
    tab.addEventListener('click', e => {
      if(['copymiss', 'customer', 'mail'].includes(tab.dataset.uwFilterIndex)){
        Array.from(document.querySelectorAll('.c-case_content-item.problem')).forEach(elm => {
          elm.classList.add('actived')
        })
      }else{
        Array.from(document.querySelectorAll('.c-case_content-item.problem')).forEach(elm => {
          elm.classList.remove('actived')
        })
      }
    })
  })
  
})
